import {
  Checkbox,
  CircularProgress,
  MenuItem,
  TablePagination,
  TableSortLabel,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Box } from "@mui/system";
import _ from "lodash";
import React, { ChangeEvent } from "react";
import {
  StyledTable,
  StyledTableContainer,
  StyledTableLoader,
} from "./styles";

const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 75, 100];

export type ColumnType = {
  key: string;
  title: string | React.ReactElement;
  render?: (item: any) => React.ReactElement | string | null | number | boolean;
  hide?: boolean;
  default?: boolean;
  width?: string;
  sort?: boolean;
  active?: boolean;
  direction?: "asc" | "desc";
};

type PaginationType = {
  totalCount: number;
  page: number;
  setPage: (page: number) => void;
  pageCount?: number;
  setPageCount?: (pageCount: number) => void;
};

type SelectionType = {
  selected: any[];
  setSelected: (selected: any[]) => void;
};

interface TableProps {
  columns: Array<ColumnType>;
  sx?: any;
  data: any[];
  loading?: boolean;
  onRowClick?: (v: any) => void;
  sortHandler?: (v: any) => void;
  pagination?: PaginationType | null;
  selection?: SelectionType;
  heading?: string;
  defaultPageLimit?: null | number;
  setDefaultLimit?: (v: any) => void;
  height?: string;
}

function HorizontalTable(props: TableProps) {
  const {
    columns,
    data = [],
    sx,
    pagination,
    loading = false,
    onRowClick,
    sortHandler,
    selection,
    heading,
    defaultPageLimit = null,
    setDefaultLimit,
    height = "60vh",
  } = props;

  const { selected = [], setSelected = () => {} } = selection || {};

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setSelected(data);
    } else {
      setSelected([]);
    }
  };

  const handleSelect = (e: React.ChangeEvent<HTMLInputElement>, item: any) => {
    e.stopPropagation();
    if (e.target.checked) {
      setSelected([...selected, item]);
    } else {
      setSelected(selected.filter((v: any) => v?.id !== item?.id));
    }
  };

  const handleRowClick = (item: any) => {
    if (!onRowClick) return;
    onRowClick(item);
  };

  const handleCreateSortHandler = (col: ColumnType) => {
    if (!sortHandler) return;
    sortHandler(col);
  };

  const handlePageChange = (_: any, page: number) => {
    pagination?.setPage(page);
    setSelected([]);
  };

  const handleRowsPerPageChange = (e: any) => {
    if (pagination?.setPageCount) {
      pagination.setPage(0);
      pagination.setPageCount(+e.target.value);
      setSelected([]);
    }
  };

  // Filter visible columns
  const visibleColumns = columns.filter((col) => !col.hide);

  // return (
  //   <StyledTableContainer  
  //    sx={{
  //       display: "flex",
  //       flexDirection: "column",
  //       height: isMobile ? "auto" : height,
  //       position: "relative",
  //       ...sx,
  //     }}>
  //     {heading && (
  //       <Typography variant="h5" textAlign="center" sx={{ py: 2 }}>
  //         {heading}
  //       </Typography>
  //     )}

  //     {/* Horizontal Scroll Wrapper */}
  //     <Box
  //      sx={{
  //          flex: 1,           // takes remaining height after pagination
  //         overflow: "auto",  // handles both directions
  //         minHeight: 0,    

  //         // Custom smooth scrollbar
  //         "&::-webkit-scrollbar": {
  //           height: 8,
  //         },
  //         "&::-webkit-scrollbar-thumb": {
  //           backgroundColor: "rgba(0,0,0,0.2)",
  //           borderRadius: "10px",
  //         },
  //         "&::-webkit-scrollbar-thumb:hover": {
  //           backgroundColor: "rgba(0,0,0,0.4)",
  //         },

  //         // Better mobile touch scrolling
  //         WebkitOverflowScrolling: "touch",
  //       }}
  //     >
  //       {/* Vertical Scroll + Fixed Height Container */}
  //       <Box
  //          sx={{
  //       flex: 1,
  //       overflowY: "auto",
  //       overflowX: "auto",
  //     }}
  //       >
  //         <StyledTable
  //           sx={{
  //             // Important: allow table to shrink/grow naturally
  //             width: "auto",
  //             minWidth: "100%", // ensures it fills container at minimum
  //             tableLayout: "auto", // default, lets columns size naturally
  //           }}
  //         >
  //           <thead>
  //             <tr>
  //               {selection && data.length > 0 && (
  //                 <th style={{ width: 50, whiteSpace: "nowrap" }}>
  //                   <Checkbox
  //                     color="secondary"
  //                     onChange={handleSelectAll}
  //                     checked={selected.length === data.length && data.length > 0}
  //                     indeterminate={
  //                       selected.length > 0 && selected.length < data.length
  //                     }
  //                   />
  //                 </th>
  //               )}
  //               {visibleColumns.map((col) => (
  //                 <th
  //                   key={col.key}
  //                   style={{
  //                     width: col.width || "auto",
  //                     minWidth: col.width || "100px", // optional: prevent collapse
  //                     whiteSpace: "nowrap",
  //                     fontWeight: 600,
  //                   }}
  //                 >
  //                   <Box display="flex" alignItems="center">
  //                     {col.title}
  //                     {col.sort && (
  //                       <TableSortLabel
  //                         active={col.active}
  //                         direction={col.direction}
  //                         onClick={() => handleCreateSortHandler(col)}
  //                         sx={{
  //                           "& .MuiTableSortLabel-icon": {
  //                             opacity: col.active ? 1 : 0.2,
  //                           },
  //                           "&:hover .MuiTableSortLabel-icon": {
  //                             opacity: 1,
  //                           },
  //                         }}
  //                       />
  //                     )}
  //                   </Box>
  //                 </th>
  //               ))}
  //             </tr>
  //           </thead>
  //           <tbody>
  //             {data.map((item, index) => (
  //               <tr key={item?.id || index} onClick={() => handleRowClick(item)}>
  //                 {selection && (
  //                   <td style={{ whiteSpace: "nowrap" }}>
  //                     <Checkbox
  //                       onChange={(e) => handleSelect(e, item)}
  //                       onClick={(e) => e.stopPropagation()}
  //                       color="secondary"
  //                       checked={Boolean(_.find(selected, { id: item?.id }))}
  //                     />
  //                   </td>
  //                 )}
  //                 {visibleColumns.map((col) => (
  //                   <td
  //                     key={col.key}
  //                     style={{
  //                       whiteSpace: "nowrap",
  //                       overflow: "hidden",
  //                       textOverflow: "ellipsis",
  //                       maxWidth: col.width ? undefined : "300px", // optional truncation
  //                     }}
  //                   >
  //                     {col.render ? (
  //                       col.render(item)
  //                     ) : (
  //                       <Typography variant="body2">
  //                         {_.get(item, col.key)}
  //                       </Typography>
  //                     )}
  //                   </td>
  //                 ))}
  //               </tr>
  //             ))}
  //                 {!loading && data?.length === 0 && (
  //                 <tr>
  //               <td
  //                 colSpan={visibleColumns.length + (selection ? 1 : 0)}
  //                 style={{ textAlign: "center", padding: "40px 0" }}
  //               >
  //                 <Typography variant="subtitle2" color="text.secondary">
  //                   No data
  //                 </Typography>
  //               </td>
  //             </tr>
  //               )}
  //           </tbody>
  //         </StyledTable>
  //       </Box>
  //     </Box>

  //     {/* Pagination */}
  //     {pagination && (
  //       <Box display="flex" justifyContent="flex-end" alignItems="center" >
  //         {setDefaultLimit && (
  //           <TextField
  //             select
  //             value={defaultPageLimit || ""}
  //             onChange={(e) => setDefaultLimit(e.target.value)}
  //             label="Default"
  //             size="small"
  //             sx={{ width: 100, mr: 2 }}
  //           >
  //             <MenuItem value="50">50</MenuItem>
  //             <MenuItem value="75">75</MenuItem>
  //             <MenuItem value="100">100</MenuItem>
  //           </TextField>
  //         )}
  //         <TablePagination
  //           component="div"
  //           count={pagination.totalCount || 0}
  //           page={pagination.page || 0}
  //           onPageChange={handlePageChange}
  //           rowsPerPage={pagination.pageCount || 10}
  //           rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
  //           onRowsPerPageChange={handleRowsPerPageChange}
  //         />
  //       </Box>
  //     )}

  //     {/* Loader & Empty State */}
  //     {loading && (
  //       <StyledTableLoader>
  //         <CircularProgress color="primary" />
  //       </StyledTableLoader>
  //     )}

  //   </StyledTableContainer>
  // );

  return (
    <StyledTableContainer
      sx={{
        display: "flex",
        flexDirection: "column",
        height: isMobile ? "auto" : height,
        position: "relative",
        ...sx,
      }}
    >
      {heading && (
        <Typography variant="h5" textAlign="center" sx={{ py: 2 }}>
          {heading}
        </Typography>
      )}

      {/* ✅ ONE single scroll box — handles both x and y */}
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          minHeight: 0,
          WebkitOverflowScrolling: "touch",
          "&::-webkit-scrollbar": { height: 8 },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(0,0,0,0.2)",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "rgba(0,0,0,0.4)",
          },
        }}
      >
        <StyledTable
          sx={{
            width: "auto",
            minWidth: "100%",
            tableLayout: "auto",
          }}
        >
          <thead>
            <tr>
              {selection && data.length > 0 && (
                <th
                  style={{
                    width: 50,
                    whiteSpace: "nowrap",
                    // ✅ sticky styles
                    position: "sticky",
                    top: 0,
                    zIndex: 3,
                    backgroundColor: "white", // 👈 change to your header bg color
                  }}
                >
                  <Checkbox
                    color="secondary"
                    onChange={handleSelectAll}
                    checked={selected.length === data.length && data.length > 0}
                    indeterminate={
                      selected.length > 0 && selected.length < data.length
                    }
                  />
                </th>
              )}
              {visibleColumns.map((col) => (
                <th
                  key={col.key}
                  style={{
                    width: col.width || "auto",
                    minWidth: col.width || "100px",
                    whiteSpace: "nowrap",
                    fontWeight: 600,
                    // ✅ sticky styles
                    position: "sticky",
                    top: 0,
                    zIndex: 3,
                    backgroundColor: "white", // 👈 change to your header bg color
                  }}
                >
                  <Box display="flex" alignItems="center">
                    {col.title}
                    {col.sort && (
                      <TableSortLabel
                        active={col.active}
                        direction={col.direction}
                        onClick={() => handleCreateSortHandler(col)}
                        sx={{
                          "& .MuiTableSortLabel-icon": {
                            opacity: col.active ? 1 : 0.2,
                          },
                          "&:hover .MuiTableSortLabel-icon": { opacity: 1 },
                        }}
                      />
                    )}
                  </Box>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.map((item, index) => (
              <tr key={item?.id || index} onClick={() => handleRowClick(item)}>
                {selection && (
                  <td style={{ whiteSpace: "nowrap" }}>
                    <Checkbox
                      onChange={(e) => handleSelect(e, item)}
                      onClick={(e) => e.stopPropagation()}
                      color="secondary"
                      checked={Boolean(_.find(selected, { id: item?.id }))}
                    />
                  </td>
                )}
                {visibleColumns.map((col) => (
                  <td
                    key={col.key}
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: col.width ? undefined : "300px",
                    }}
                  >
                    {col.render ? (
                      col.render(item)
                    ) : (
                      <Typography variant="body2">
                        {_.get(item, col.key)}
                      </Typography>
                    )}
                  </td>
                ))}
              </tr>
            ))}

            {!loading && data?.length === 0 && (
              <tr>
                <td
                  colSpan={visibleColumns.length + (selection ? 1 : 0)}
                  style={{ textAlign: "center", padding: "40px 0" }}
                >
                  <Typography variant="subtitle2" color="text.secondary">
                    No data
                  </Typography>
                </td>
              </tr>
            )}
          </tbody>
        </StyledTable>
      </Box>

      {/* Pagination */}
      {pagination && (
        <Box display="flex" justifyContent="flex-end" alignItems="center">
          {setDefaultLimit && (
            <TextField
              select
              value={defaultPageLimit || ""}
              onChange={(e) => setDefaultLimit(e.target.value)}
              label="Default"
              size="small"
              sx={{ width: 100, mr: 2 }}
            >
              <MenuItem value="50">50</MenuItem>
              <MenuItem value="75">75</MenuItem>
              <MenuItem value="100">100</MenuItem>
            </TextField>
          )}
          <TablePagination
            component="div"
            count={pagination.totalCount || 0}
            page={pagination.page || 0}
            onPageChange={handlePageChange}
            rowsPerPage={pagination.pageCount || 10}
            rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        </Box>
      )}

      {/* Loader */}
      {loading && (
        <StyledTableLoader>
          <CircularProgress color="primary" />
        </StyledTableLoader>
      )}
    </StyledTableContainer>
  );
}

export default HorizontalTable;